// src/collections.js
const Collections = {
  USERS: "users",
  INVENTORY_CATEGORY: "inventoryCategory",
  INVENTORY_ITEMS:'inventoryItems',
  INVOICES: "invoices",
  CK_INVENTORY: "ck_inventory",
  CK_BATCHES: "ck_batches",
  CK_RECIPES: "ck_recipes",
  // Add more collections as needed
};

export default Collections;
